import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Injectable} from '@angular/core';
import {concatMap, filter, map, withLatestFrom} from 'rxjs/operators';
import {AppState} from './index';
import {Action, select, Store} from '@ngrx/store';
import {isActiveCourseLessonsLoaded, selectActiveCourse, selectAllLessons, selectUser} from './selectors';
import {UserLessonStatusDbService} from '../services/user-lesson-status.db.service';

import {isAnonymousUser, User} from '../models/user.model';
import {CourseActions, UserLessonStatusActions} from './action-types';
import {userLessonsStatusLoaded} from './user-lesson-status.actions';
import { selectActiveCourseLessonsWatched, selectAllLessonsWatched } from "./user-lesson-status.selectors";
import { UserActivityLogService } from "../services/user-activity-log.service";
import {UserLessonStatusState} from './user-lesson-status.reducer';


@Injectable({
  providedIn: 'root'
})
export class UserLessonStatusEffects {

  loadLessonsWatchedByCourseIfNeeded$ = createEffect(() => this.actions$
    .pipe(
      ofType(CourseActions.loadCourseDetail),
      withLatestFrom(this.store.pipe(select(isActiveCourseLessonsLoaded))),
      filter(([action, loaded]) => !loaded),
      map(([action, loaded]) => action),
      withLatestFrom(this.store.pipe(select(selectUser))),
      filter(([action, user]) => !isAnonymousUser(user)),
      concatMap(([{courseId}, user]) =>
        this.userLessonsDb.loadLessonsWatchedByCourse(user.id, courseId)
          .pipe(
            map(userLessonsStatusList => [courseId, userLessonsStatusList])
          )
      ),
      map( ([courseId, userLessonsStatusList]:any) => userLessonsStatusLoaded({courseId,userLessonsStatusList}))
    ));

  saveLessonStatus = createEffect(() =>this.actions$
    .pipe(
      ofType(UserLessonStatusActions.updateLessonWatchStatus),
      withLatestFrom(this.store.pipe(select(selectUser))),
      filter(([action, user]) => !isAnonymousUser(user)),
      concatMap(([action, user]) => this.userLessonsDb.saveLessonStatus(user.id, action.userLessonStatus))
    ),
    {dispatch: false});

  constructor(
    private actions$ :Actions,
    private store: Store<AppState>,
    private userLessonsDb: UserLessonStatusDbService,
    private userActivitiyLogService: UserActivityLogService) {

  }

}
